import React, { createContext, useContext } from 'react'

import MODAL from '../utils/modals'

import { useServiceScheduleContext, actionTypes } from './serviceScheduleContext'
import { getNames } from 'src/services/professionalService'

export const ProfessionalContext = createContext()

// contexto de estado
export function ProfessionalContextProvider ({ children }) {
  const { state, dispatch } = useServiceScheduleContext()

  // seta as datas disponiveis de acordo com a data selecionada
  const setAvailableDatesByProfessional = (professionalId) => {
    const { availableSlots, scheduleBody, error } = state

    let newState = {
      ...state
    }

    // Inicialização dos arrays de dias disponíveis
    const availableDates = availableSlots[professionalId]
      ? Object.keys(availableSlots[professionalId]).map((day) => parseInt(day))
      : []

    newState = {
      ...newState,
      scheduleBody: {
        ...scheduleBody,
        professional_id: professionalId
      },
      error: {
        ...error,
        professional_id: undefined
      },
      availableDates
    }

    return newState
  }

  // abre modal do profissional
  const handleViewProfessional = async (professionalId, e) => {
    e.stopPropagation()
    const { serviceData, partnersData } = state
    const professionalList = await getNames([professionalId])
    const professional = professionalList[0]
    const servicesList = serviceData.filter((service) =>
      professional.services.includes(service.value)
    )

    const partner = partnersData.find((partner) => partner.id === professional.partner)
    dispatch({
      type: actionTypes.UPDATE_STATE,
      payload: {
        modal: MODAL.PROFESSIONAL_PROFILE(professional, servicesList, partner)
      }
    })
  }

  // seleciona o primeiro profissional da lista
  const handleNoPreferenceProfessional = (props) => {
    const { context } = props

    const { professionalData } = state

    context.showLoader()

    const newState = setAvailableDatesByProfessional(professionalData[0]?.id)

    dispatch({
      type: actionTypes.UPDATE_STATE,
      payload: {
        ...newState,
        noPreference: true
      }
    })

    context.hideLoader()
  }

  // seleciona profissinal
  const handleSelectedProfessional = (professionalId, props) => {
    const { context } = props

    context.showLoader()

    const newState = setAvailableDatesByProfessional(professionalId)

    dispatch({
      type: actionTypes.UPDATE_STATE,
      payload: {
        ...newState,
        noPreference: false
      }
    })

    context.hideLoader()
  }

  // busca profissionais
  const getProfessionals = async (props) => {
    const { context } = props

    context.showLoader()

    const { availableSlots, formList, havePayment } = state

    const professionalIds = Object.keys(availableSlots).filter(
      (professionalId) => professionalId !== ''
    )

    const professionalList = await getNames(professionalIds)

    const professionalData = professionalList
      .map(({ id, name, photo, enabledPayment, ratingAverage }) => ({ id, name, photo, enabledPayment: enabledPayment || false, ratingAverage }))
      .filter(({ enabledPayment }) => !formList.length || (havePayment && enabledPayment === havePayment) || !havePayment)
      .filter(({ id }) => {
        if (formList.length > 0) {
          return formList.every(
            (form) => (state.scheduleBody.selectDay === form.body.selectDay && state.scheduleBody.selectTime === form.body.selectTime) ? form.body.professional_id !== id : true)
        }
        return true
      })

    dispatch({
      type: actionTypes.UPDATE_STATE,
      payload: {
        professionalData
      }
    })

    context.hideLoader()
  }

  // exporta as funções
  const functions = {
    handleViewProfessional,
    handleNoPreferenceProfessional,
    handleSelectedProfessional,
    getProfessionals
  }

  return (
    <ProfessionalContext.Provider value={{ functions }}>
      {children}
    </ProfessionalContext.Provider>
  )
}

// Hook para acessar o contexto
export function useProfessionalContext () {
  const context = useContext(ProfessionalContext)
  if (!context) {
    throw new Error('useProfessionalContext deve ser usado dentro de um Provider!')
  }

  const { functions } = context
  return { functions }
}
